import axios, {
  AxiosInstance,
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';
import { mediaApiSign } from './index';

const { DEV, VITE_BASE_URL, VITE_BASE_DOMAIN, VITE_MEDIA_AUTHORIZATION } = import.meta
  .env;
const defaultConfig: AxiosRequestConfig = {
  timeout: 30 * 1000,
  baseURL: DEV ? VITE_BASE_URL : VITE_BASE_DOMAIN + VITE_BASE_URL,
};

class Request {
  service: AxiosInstance;

  public constructor(config: AxiosRequestConfig) {
    this.service = axios.create(config);

    // 请求拦截
    this.service.interceptors.request.use(
      (reqConfig: InternalAxiosRequestConfig) => {
        const tmpConfig = { ...reqConfig };
        tmpConfig.headers.set('x-user', 'admin');
        if (tmpConfig.url?.includes('/ucs')) {
          const mediaSign = mediaApiSign(tmpConfig.url, tmpConfig.params);
          if (typeof tmpConfig.headers.set === 'function') {
            Object.entries(mediaSign).forEach(([key, value]) => {
              tmpConfig.headers.set(key, value);
            });
            tmpConfig.headers.set('Authorization', VITE_MEDIA_AUTHORIZATION);
          }
        }
        return {
          ...tmpConfig,
        };
      },
      (reqError: AxiosError) => {
        Promise.reject(reqError);
      },
    );

    // 响应拦截
    this.service.interceptors.response.use(
      (res: AxiosResponse) => {
        return res.data;
      },
      (resError: AxiosError) => {
        Promise.reject(resError);
      },
    );
  }

  get<T>(url: string, params?: AxiosRequestConfig): Promise<T> {
    return this.service.get(url, params);
  }

  post<T>(url: string, params?: AxiosRequestConfig): Promise<T> {
    return this.service.post(url, params);
  }

  put<T>(url: string, params?: AxiosRequestConfig): Promise<T> {
    return this.service.put(url, params);
  }

  delete<T>(url: string, params?: AxiosRequestConfig): Promise<T> {
    return this.service.delete(url, params);
  }
}

export default new Request(defaultConfig);
